export function landingBanner(entry) {
  const { description = null, displayTitle = null } = entry || {}

  if (description !== null && displayTitle !== null) {
    return { text: description, title: displayTitle }
  } else return null
}
